// Summary Sidebar Component - Right Panel

import React from 'react';
import { RouteSummaryCards } from './RouteSummaryCards';

interface SummarySidebarProps {
  selectedRoute: any | null;
  routes: any[];
  selectedCustomersCount: number;
  selectedVehicles: any[];
  solutionStats: {
    vehiclesUsed: number;
    totalTime: number;
    totalDistance: number;
  };
}

export const SummarySidebar: React.FC<SummarySidebarProps> = ({
  selectedRoute,
  routes,
  selectedCustomersCount,
  selectedVehicles,
  solutionStats
}) => {
  return (
    <div className="summary-sidebar">
      <div className="summary-sidebar-header">
        <i className="pi pi-chart-bar"></i>
        <span>Rota Özeti</span>
      </div>
      <div className="summary-sidebar-content">
        <RouteSummaryCards
          selectedRoute={selectedRoute}
          routes={routes}
          selectedCustomersCount={selectedCustomersCount}
          selectedVehicles={selectedVehicles}
          solutionStats={solutionStats}
        />
      </div>
    </div>
  );
};
